export default __webpack_public_path__ + "static/media/map-icon.3c0fae94.svg";